export enum StandardStatus {
  active = "Actif",
  archived = "Archivé",
}

export const StandardStatusColors = new Map<StandardStatus, string>([
  [StandardStatus.active, "#86EFAC"],
  [StandardStatus.archived, "#E879F9"],
]);
